<template>
  <div class="main">
    <div class="mainContent">
      <div>
        <div>
          <div class="title">
            <img :src="logoSrc" alt="" style="height: 36px; width: 36px" />
          </div>
          <div class="copyright">© 2022-2024 ™易回复 版权所有</div>
        </div>
        <div>
          <div class="title">特征</div>
          <ul class="list-unstyled text-small">
            <li><a class="text-muted" href="#">快捷回复</a></li>
            <li><a class="text-muted" href="#">客服聊天助手</a></li>
            <li><a class="text-muted" href="#">客服聊天工具</a></li>
            <li><a class="text-muted" href="#">PasteDesk</a></li>
          </ul>
        </div>
        <div>
          <div class="title">联系我们</div>
          <ul class="list-unstyled text-small">
            <li>
              <a class="text-muted" href="https://t.me/yihuifu168">联系客服</a>
            </li>
            <li>
              <a class="text-muted" href="https://t.me/yihuifu168"
                >客服二维码</a
              >
            </li>
            <li style="display: flex; flex-wrap: nowrap">
              <div style="text-align: center;">
                <img :src="kfSrc" alt="" style="height: 87px" />
                <div class="text-muted">telegram</div>
              </div>
              <div style="margin-left: 10px;text-align: center;">
                <img :src="wxKfSrc" alt="" style="height: 87px" />
                <div class="text-muted">微信</div>
              </div>
            </li>
            <!-- <li><a class="text-muted" href="#">微信:</a></li>
          <li><a class="text-muted" href="#">邮箱:Message@88.com</a></li> -->
          </ul>
        </div>
      </div>
      <div>
        <a href="https://beian.miit.gov.cn/" v-if="chromeCheck"
          >蜀ICP备2024115121号</a
        >
      </div>
    </div>
  </div>
</template>
<script setup>
import logoSrc from "@/assets/imgs/footer/footerLogo.jpg";
import kfSrc from "@/assets/imgs/kefu.png";
import wxKfSrc from "@/assets/imgs/wxKfSrc.jpg";
let origin = window.location.origin;
let chromeCheck = origin.includes("www.traneasy.vip");
// import Wechat from "@/assets/imgs/footer/wechat.png";
</script>
<style scoped>
.main {
  background: #f7f7f7;
}
.mainContent {
  padding: 2rem 0 1rem;
}
.mainContent > div:first-child {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.mainContent > div:last-child {
  margin-top: 1.5rem;
  font-size: 12px;
  background: #2b333b;
  border-radius: 8px;
  color: #848993;
  padding: 8px;
  display: flex;
  justify-content: center;
}
.copyright {
  color: #6c757d !important;
  font-size: 0.8rem;
  font-weight: 400;
}
.title {
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: #212529;
  text-align: left;
}
.list-unstyled {
  padding-left: 0;
  list-style: none;
}
.text-muted {
  color: #6c757d !important;
}
.text-muted:hover {
  text-decoration: underline;
}
@media (max-width: 768px) {
}
</style>
